import { ColorsV2 } from '../design-system/colors_v2'

/**
 * @todo Move to Storybook and handle colors through the design system instead of handling them here.
 * currently used for the fallback of the document categories
 */
export function getDefaultBgColor() {
  return ColorsV2.lightBlue
}
